import React from "react";
import Square from './assets/square.jpg';

export default class SideBar extends React.Component {

    render(){
        return(
            <div className="side-bar-container">
                <div className="side-bar-social">
                    <h3>Social Media</h3>
                    <div>
                        <div className="icon-div">
                            <i class="fa fa-facebook" aria-hidden="true"></i>
                        </div>
                        <div className="icon-div">
                            <i class="fa fa-twitter" aria-hidden="true"></i>
                        </div>
                        <div className="icon-div">
                            <i class="fa fa-instagram" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>

                <div>
                    <h3>Recent Posts</h3>
                    <div className="recent-post-item">
                        <img src={Square} className="recent-posts-img" />
                        <h3>This is some random recent post title that will go here</h3>
                    </div>
                    <div className="recent-post-item">
                        <img src={Square} className="recent-posts-img" />
                        <h3>This is some random recent post title that will go here</h3>
                    </div>
                    <div className="recent-post-item">
                        <img src={Square} className="recent-posts-img" />
                        <h3>This is some random recent post title that will go here</h3>
                    </div>
                    <div className="recent-post-item">
                        <img src={Square} className="recent-posts-img" />
                        <h3>This is some random recent post title that will go here</h3>
                    </div>
                    <div className="recent-post-item">
                        <img src={Square} className="recent-posts-img" />
                        <h3>This is some random recent post title that will go here</h3>
                    </div>
                </div>
            </div>
        )
    }
}